import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { QuicklinkModule } from 'ngx-quicklink';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../rollbar_config';
import { HandleUnrecoverableStateService  } from './services/service-workers/handle-unrecoverable-state.service';
import { CheckForUpdateService } from './services/service-workers/check-for-update.service';
import { LogUpdateService } from './services/service-workers/log-update.service';
import { PromptUpdateService } from './services/service-workers/prompt-update.service';
import { NewVersionCheckerComponent } from './new-version-checker/new-version-checker.component'

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
	declarations: [	
		AppComponent
		, NewVersionCheckerComponent
   	]
	, imports: [
		BrowserModule
		, CoreModule
		, QuicklinkModule
		, ServiceWorkerModule.register(
			'ngsw-worker.js'
			, {
				enabled: true
				, registrationStrategy: 'registerWhenStable:30000'
  			}
		)
	]
	, providers: [
		CheckForUpdateService
		, LogUpdateService
		, PromptUpdateService
		, HandleUnrecoverableStateService
		, { 
			provide: ErrorHandler
			, useClass: RollbarErrorHandler 
		}
		, { 
			provide: RollbarService
			, useFactory: rollbarFactory 
		}
	]
	, bootstrap: [ AppComponent ]
})
export class AppModule { }
